import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { inject, onMounted, reactive, ref } from "vue";
import Order from "@/model/Order.model";
import { LedgerServiceSymbol, OrderItemServiceSymbol, OrderServiceSymbol } from "@/InjectionSymbols";
import StatusDisplay from "@/components/admin/StatusDisplay.vue";
import { OrderStatus } from "@/model/enum/OrderStatus";
import { Formatter } from "@/util/Formatter";
import OrderPayments from "@/components/admin/OrderPayments.vue";
import OrderInvoices from "@/components/admin/OrderInvoices.vue";
import AddOrderItemPanel from "@/components/admin/AddOrderItemPanel.vue";
import OrderItemRow from "@/components/admin/OrderItemRow.vue";
import TotalsDisplay from "@/components/TotalsDisplay.vue";
import { validationRules } from "@/ValidationRules";
import { EditState } from "@/model/enum/EditState";
import EmailDialog from "@/components/admin/EmailDialog.vue";
import { EmailType } from "@/model/enum/EmailType";
import CancelOrderDialog from "@/components/admin/CancelOrderDialog.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'EditOrderView',
    props: {
        id: {
            type: String,
            required: true
        }
    },
    setup(__props) {
        const orderService = inject(OrderServiceSymbol);
        const orderItemService = inject(OrderItemServiceSymbol);
        const ledgerService = inject(LedgerServiceSymbol);
        const editOrder = reactive(new Order());
        const ledgers = reactive([]);
        let selectedLedger = ref(null);
        let form = ref(null);
        const invoiceComponent = ref();
        let notesForm = ref(null);
        let cancelInvoiceDialog = ref(false);
        const props = __props;
        onMounted(() => {
            orderService?.loadOrder(props.id, orderLoaded);
            ledgerService?.loadAllLedgers().then(ledgersResponse => {
                ledgers.length = 0;
                ledgers.push(...ledgersResponse);
            });
        });
        function orderLoaded(order) {
            editOrder.assign(order);
        }
        function onOrderAccepted(emailHtmlContent) {
            form.value.resetValidation();
            form.value.validate().then((result) => {
                if (result.valid) {
                    orderService?.acceptOrder(editOrder.id, selectedLedger.value.id, {
                        htmlContent: emailHtmlContent
                    })
                        .then(() => orderService?.loadOrder(editOrder.id.toString(), orderLoaded)
                        .then(() => {
                        invoiceComponent.value.refreshInvoices(1);
                    }));
                }
            });
        }
        function onOrderDeclined(emailHtmlContent) {
            orderService?.declineOrder(editOrder.id, {
                htmlContent: emailHtmlContent
            })
                .then(() => orderService?.loadOrder(editOrder.id.toString(), orderLoaded));
        }
        function onOrderCancelled(charge) {
            let newExpectedInvoiceCount = 0;
            if (editOrder.invoiced) {
                newExpectedInvoiceCount++;
            }
            if (charge != null) {
                newExpectedInvoiceCount++;
            }
            orderService?.cancelOrder(editOrder.id, charge)
                .then((response) => {
                orderLoaded(response.data);
                invoiceComponent.value.refreshInvoices(newExpectedInvoiceCount);
            });
        }
        function onOrderPaymentAdded() {
            orderService?.loadOrder(props.id, orderLoaded);
        }
        function removeOrderItem(orderItem) {
            orderItemService.deleteOrderItem(editOrder.id, orderItem.id)
                .then((response) => {
                orderLoaded(response.data);
            });
        }
        function onFocusChange(focused) {
            if (!focused) {
                notesForm.value.validate().then((result) => {
                    if (result.valid) {
                        orderService.updateOrder(editOrder);
                    }
                });
            }
        }
        function cancelInvoice() {
            orderService.cancelInvoice(props.id)
                .then((response) => {
                orderLoaded(response.data);
                cancelInvoiceDialog.value = false;
                invoiceComponent.value.refreshInvoices(1);
            });
        }
        return (_ctx, _cache) => {
            const _component_v_container = _resolveComponent("v-container");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_dialog = _resolveComponent("v-dialog");
            const _component_v_divider = _resolveComponent("v-divider");
            return (_openBlock(), _createBlock(_component_v_card, { class: "d-flex flex-wrap ma-0" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_container, {
                        fluid: "",
                        class: "text-h4 text-start"
                    }, {
                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createTextVNode("Buchungsübersicht")
                        ])),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { class: "v-col-3 pt-0 ma-0" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, { class: "mb-4" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_form, {
                                        ref_key: "form",
                                        ref: form
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "d-flex flex-wrap" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-6 pa-0" }, {
                                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                            _createTextVNode("Buchungstatus")
                                                        ])),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_container, { class: "v-col-6 text-end pa-0" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(StatusDisplay, {
                                                                "order-status": editOrder.orderStatus,
                                                                "payment-status": editOrder.paymentStatus
                                                            }, null, 8, ["order-status", "payment-status"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    (editOrder.orderStatus === _unref(OrderStatus).NEW && editOrder.id)
                                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                                            key: 0,
                                                            class: "pa-0 pr-2 mt-2 v-col-12 d-flex"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_select, {
                                                                    class: "compact pr-2 flex-grow-1 v-col-6",
                                                                    density: "compact",
                                                                    modelValue: _unref(selectedLedger),
                                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(selectedLedger) ? (selectedLedger).value = $event : selectedLedger = $event)),
                                                                    items: ledgers,
                                                                    "item-title": "ledgerName",
                                                                    label: "Konto",
                                                                    variant: "outlined",
                                                                    rules: [_unref(validationRules).required],
                                                                    "return-object": ""
                                                                }, null, 8, ["modelValue", "items", "rules"]),
                                                                _createVNode(_component_v_container, { class: "pa-0" }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(EmailDialog, {
                                                                            "mail-type": _unref(EmailType).ORDER_ACCEPTED,
                                                                            "order-id": editOrder.id,
                                                                            onOnDialogConfirm: onOrderAccepted
                                                                        }, {
                                                                            activator: _withCtx(({ props }) => [
                                                                                _createVNode(_component_v_btn, _mergeProps({ class: "w-100" }, props), {
                                                                                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                                        _createTextVNode(" Annehmen ")
                                                                                    ])),
                                                                                    _: 2
                                                                                }, 1040)
                                                                            ]),
                                                                            confirmBtnText: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                                _createTextVNode("Annehmen und Mail versenden")
                                                                            ])),
                                                                            attachementNote: _withCtx(() => _cache[10] || (_cache[10] = [
                                                                                _createTextVNode("Die generierte Rechnung wird an diese Mail automatisch angehängt. ")
                                                                            ])),
                                                                            _: 1
                                                                        }, 8, ["mail-type", "order-id"])
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true),
                                                    (editOrder.orderStatus === _unref(OrderStatus).NEW && editOrder.id)
                                                        ? (_openBlock(), _createBlock(_component_v_container, {
                                                            key: 1,
                                                            class: "pa-0 pl-2 mt-2"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(EmailDialog, {
                                                                    "mail-type": _unref(EmailType).ORDER_DECLINED,
                                                                    "order-id": editOrder.id,
                                                                    onOnDialogConfirm: onOrderDeclined
                                                                }, {
                                                                    activator: _withCtx(({ props }) => [
                                                                        _createVNode(_component_v_btn, _mergeProps({ class: "w-100" }, props), {
                                                                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                                _createTextVNode(" Ablehnen ")
                                                                            ])),
                                                                            _: 2
                                                                        }, 1040)
                                                                    ]),
                                                                    confirmBtnText: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                        _createTextVNode("Buchung ablehnen und Mail versenden")
                                                                    ])),
                                                                    _: 1
                                                                }, 8, ["mail-type", "order-id"])
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true),
                                                    (editOrder.orderStatus === _unref(OrderStatus).CONFIRMED)
                                                        ? (_openBlock(), _createBlock(_component_v_container, { key: 2 }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(CancelOrderDialog, {
                                                                    "order-total": editOrder.totals.grossChargeableTotal,
                                                                    onConfirm: onOrderCancelled
                                                                }, {
                                                                    activator: _withCtx(({ props }) => [
                                                                        _createVNode(_component_v_btn, _mergeProps({ class: "w-100" }, props), {
                                                                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                                _createTextVNode("Stornieren")
                                                                            ])),
                                                                            _: 2
                                                                        }, 1040)
                                                                    ]),
                                                                    _: 1
                                                                }, 8, ["order-total"])
                                                            ]),
                                                            _: 1
                                                        }))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 512)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card, { fluid: "" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "text-start d-flex font-weight-bold" }, {
                                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                                            _createTextVNode(" Buchungsdetails ")
                                        ])),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_form, { ref: "" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        class: "compact",
                                                        "model-value": editOrder.bookingNumber,
                                                        label: "Buchungsnummer",
                                                        disabled: "",
                                                        variant: "outlined"
                                                    }, null, 8, ["model-value"]),
                                                    _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        class: "compact",
                                                        "model-value": editOrder.ledger?.ledgerName ? editOrder.ledger.ledgerName : 'Nicht zugewiesen',
                                                        label: "Konto",
                                                        disabled: "",
                                                        variant: "outlined"
                                                    }, null, 8, ["model-value"]),
                                                    _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        class: "compact",
                                                        modelValue: editOrder.paymentMethod,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((editOrder.paymentMethod) = $event)),
                                                        label: "Zahlungsmethode",
                                                        disabled: "",
                                                        variant: "outlined"
                                                    }, null, 8, ["modelValue"]),
                                                    _createVNode(_component_v_text_field, {
                                                        density: "compact",
                                                        class: "compact",
                                                        "model-value": _unref(Formatter).dateTime(editOrder.orderDatetime),
                                                        label: "Buchungsdatum",
                                                        disabled: "",
                                                        variant: "outlined"
                                                    }, null, 8, ["model-value"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }, 512)
                                ]),
                                _: 1
                            }),
                            _createVNode(OrderPayments, {
                                "order-id": Number(editOrder.id),
                                onPaymentAdded: onOrderPaymentAdded
                            }, null, 8, ["order-id"]),
                            (editOrder.id && editOrder.ledger)
                                ? (_openBlock(), _createBlock(OrderInvoices, {
                                    key: 0,
                                    "order-id": editOrder.id,
                                    "order-status": editOrder.orderStatus,
                                    "edit-state": editOrder.editState,
                                    invoiced: editOrder.invoiced,
                                    onOrderUpdated: orderLoaded,
                                    ref_key: "invoiceComponent",
                                    ref: invoiceComponent
                                }, null, 8, ["order-id", "order-status", "edit-state", "invoiced"]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_container, { class: "v-col-9 pt-0" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_container, { class: "v-col-12 pa-0 ma-0 d-flex flex-wrap" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_card, {
                                        class: "v-col-3 mr-2 d-flex flex-wrap pa-4",
                                        onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$router.push({ name: 'admin-customers-edit', params: { id: editOrder.customer.id.toString() } })))
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12 pl-0 pt-0" }, {
                                                default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createTextVNode("Kunde")
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_table, { class: "customer-info" }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("tr", null, [
                                                        _cache[16] || (_cache[16] = _createElementVNode("th", null, "Firma", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.company), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[17] || (_cache[17] = _createElementVNode("th", null, "Name", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.firstname) + " " + _toDisplayString(editOrder.customer.lastname), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[18] || (_cache[18] = _createElementVNode("th", null, "Strasse", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.street) + " " + _toDisplayString(editOrder.customer.unitNumber), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[19] || (_cache[19] = _createElementVNode("th", null, "Ort", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.postcode) + " " + _toDisplayString(editOrder.customer.city), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[20] || (_cache[20] = _createElementVNode("th", null, "Telefon", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.phone), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[21] || (_cache[21] = _createElementVNode("th", null, "Mobil", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.mobile), 1)
                                                    ]),
                                                    _createElementVNode("tr", null, [
                                                        _cache[22] || (_cache[22] = _createElementVNode("th", null, "Email", -1)),
                                                        _createElementVNode("td", null, _toDisplayString(editOrder.customer.email), 1)
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_card, { class: "d-flex flex-wrap flex-grow-1 ml-2 pa-4" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "text-start font-weight-bold v-col-12 pl-0 pt-0" }, {
                                                default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                    _createTextVNode("Notizen")
                                                ])),
                                                _: 1
                                            }),
                                            _createVNode(_component_v_form, {
                                                ref_key: "notesForm",
                                                ref: notesForm,
                                                class: "v-col-12"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_textarea, {
                                                        modelValue: editOrder.internalRemarks,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((editOrder.internalRemarks) = $event)),
                                                        "onUpdate:focused": onFocusChange,
                                                        rules: [_unref(validationRules).maxLength(1000)]
                                                    }, null, 8, ["modelValue", "rules"])
                                                ]),
                                                _: 1
                                            }, 512)
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card, { class: "mt-4 v-col-12" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_container, { class: "d-flex ma-0 v-col-12" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_container, { class: "ma-0 pa-0 text-start text-h4" }, {
                                                default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                    _createTextVNode("Gebuchte Leistungen")
                                                ])),
                                                _: 1
                                            }),
                                            (editOrder.editState != _unref(EditState).LOCKED)
                                                ? (_openBlock(), _createBlock(AddOrderItemPanel, {
                                                    key: 0,
                                                    "order-id": Number(editOrder.id),
                                                    onOrderUpdated: orderLoaded,
                                                    class: "v-col-12"
                                                }, null, 8, ["order-id"]))
                                                : _createCommentVNode("", true),
                                            (editOrder.editState == _unref(EditState).LOCKED && editOrder.invoiced)
                                                ? (_openBlock(), _createBlock(_component_v_dialog, {
                                                    key: 1,
                                                    modelValue: _unref(cancelInvoiceDialog),
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (_isRef(cancelInvoiceDialog) ? (cancelInvoiceDialog).value = $event : cancelInvoiceDialog = $event)),
                                                    "max-width": "600px"
                                                }, {
                                                    activator: _withCtx(({ props }) => [
                                                        _createVNode(_component_v_btn, _mergeProps(props, { "data-cy": "edit-items" }), {
                                                            default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                                _createTextVNode("Bearbeiten")
                                                            ])),
                                                            _: 2
                                                        }, 1040)
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_card, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_card_title, { class: "text-h5 pa-4" }, {
                                                                    default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                                        _createTextVNode(" Rechnung stornieren ")
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                                                    default: _withCtx(() => _cache[27] || (_cache[27] = [
                                                                        _createElementVNode("p", null, "Für diese Buchung wurde eine Rechnung erstellt. Storniere die aktuelle Rechnung, um die Buchung zu bearbeiten. Keine Sorge, du kannst später eine neue Rechnung ausstellen.", -1)
                                                                    ])),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_component_v_spacer),
                                                                        _createVNode(_component_v_btn, {
                                                                            onClick: _cache[4] || (_cache[4] = ($event) => (_isRef(cancelInvoiceDialog) //@ts-ignore
                                                                                ? cancelInvoiceDialog.value = false : cancelInvoiceDialog = false))
                                                                        }, {
                                                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                                                _createTextVNode("Abbrechen")
                                                                            ])),
                                                                            _: 1
                                                                        }),
                                                                        _createVNode(_component_v_btn, {
                                                                            onClick: cancelInvoice,
                                                                            "data-cy": "confirm"
                                                                        }, {
                                                                            default: _withCtx(() => _cache[29] || (_cache[29] = [
                                                                                _createTextVNode("Rechnung Stornieren")
                                                                            ])),
                                                                            _: 1
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        })
                                                    ]),
                                                    _: 1
                                                }, 8, ["modelValue"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editOrder.orderItems, (orderItem, index) => {
                                        return (_openBlock(), _createBlock(OrderItemRow, {
                                            class: "my-2",
                                            key: index,
                                            "order-item": orderItem,
                                            "order-id": editOrder.id,
                                            "edit-state": editOrder.editState,
                                            "is-cancelled": editOrder.orderStatus === _unref(OrderStatus).CANCELLED,
                                            onRemoveItem: removeOrderItem,
                                            onOrderUpdated: orderLoaded,
                                            "data-cy": "order-item-row"
                                        }, null, 8, ["order-item", "order-id", "edit-state", "is-cancelled"]));
                                    }), 128)),
                                    _createVNode(_component_v_divider),
                                    _createVNode(TotalsDisplay, {
                                        totals: editOrder.totals,
                                        "is-cancelled": editOrder.orderStatus === _unref(OrderStatus).CANCELLED
                                    }, null, 8, ["totals", "is-cancelled"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
